<template>
  <div class="new__select-contaienr" v-click-out-side>
    <div class="input__contaienr">
      <slot name="icon">
        <img class="icon" src="@/assets/images/1/bizhong.png" alt="">
      </slot>
      <input type="text" :value="value">
      <img class="select" src="@/assets/images/1/juxing.png" alt="">
    </div>
    <ul class="list__container" v-if="isVisable">
      <li
        v-for="(item, ind) in selectList"
        :key="ind"
        @click="onSelectChange(item.value)"
        class="option__item"
        :class="item.value === value ? 'active' : ''">
        {{item.label}}
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  name: 'c-new-select',
  props: {
    selectList: {
      type: Array,
      default: () => [],
    },
    value: {
      type: String,
      default: () => '',
    },
  },
  directives: {
    clickOutSide: { // 指令的生命周期
      bind(el, bindings, vnode) {
        // 把事件绑定在document上
        const handler = (e) => {
          if (el.contains(e.target)) {
            // 判断一下是否当前面板已经显示出来了
            if (!vnode.context.isVisable) {
              vnode.context.focus();
            }
          } else if (vnode.context.isVisable) {
            vnode.context.blur();
          }
        };
        // eslint-disable-next-line no-param-reassign
        el.handler = handler;
        document.addEventListener('click', handler);
      },
      unbind(el) {
        document.removeEventListener('click', el.handler);
      },
    },
  },
  data() {
    return {
      isVisable: false,
    };
  },
  methods: {
    focus() {
      this.isVisable = true;
    },
    blur() {
      this.isVisable = false;
    },
    onSelectChange(val) {
      this.$emit('input', val);
      this.blur();
    },
  },
};
</script>

<style lang="stylus" scoped>
.new__select-contaienr {
  width: 132px;
  height: 26px;
  position relative;
}
.input__contaienr {
  width: 100%;
  height: 100%;
  border: 0.5px solid rgba(51, 51, 51, 0.3);
  border-radius: 2px;
  display: flex;
  align-items: center;
  padding: 0 5px;
  box-sizing: border-box;
  cursor: pointer;
}
.input__contaienr input {
  width 100%;
  height 100%;
  padding: 0 8px;
  box-sizing: border-box;
  color: #737373;
}
.input__contaienr .icon{
  width 16px;
  height auto;
  display block;
}
.input__contaienr .select{
  width: 18px;
  height: 7px;
  display: block;
}
.list__container {
  position absolute;
  color: #000000d9;
  font-size: 14px;
  background: #fff;
  border-radius: 2px;
  box-shadow: 0 3px 6px -4px #0000001f, 0 6px 16px #00000014, 0 9px 28px 8px #0000000d;
  transition: margin .3s;
  border: 1px solid #f0f0f0;
  z-index 1000;
  width 100%;
}
.option__item {
  height 32px;
  line-height 32px;
  padding 0 10px;
  box-sizing border-box;
}
.option__item:hover {
  background-color: #f5f5f5;
}
.option__item.active {
  background-color: #e6f7ff;
}
</style>
